import React from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { BRAND, primaryButtonSx } from "../../components/auth/authTheme";

/** Fixed footer for mobile profile edit forms (outside scroll area) */
export const MobileFormFooter = ({ onCancel, isSubmitting }) => (
  <Box
    sx={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1400,
      bgcolor: "#fff",
      borderTop: `1px solid ${BRAND.border}`,
      boxShadow: "0 -4px 20px rgba(26, 43, 74, 0.12)",
      px: 2,
      py: 1.5,
      pb: "max(12px, env(safe-area-inset-bottom))",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    <Button
      variant="contained"
      type="submit"
      fullWidth
      disabled={isSubmitting}
      sx={{
        ...primaryButtonSx,
        minHeight: 48,
        borderRadius: "12px",
      }}
    >
      Save Changes
    </Button>
    <Button
      variant="outlined"
      onClick={onCancel}
      fullWidth
      disabled={isSubmitting}
      sx={{
        minHeight: 44,
        borderRadius: "12px",
        textTransform: "none",
        fontWeight: 600,
        borderColor: BRAND.border,
        color: BRAND.navy,
      }}
    >
      Cancel
    </Button>
  </Box>
);

export const ProfileFieldLabel = ({ children }) => (
  <Typography
    sx={{
      color: BRAND.muted,
      fontWeight: 600,
      fontSize: "0.6875rem",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      mb: 0.5,
    }}
  >
    {children}
  </Typography>
);

export const ProfileField = ({ label, value }) => {
  const display = value === null || value === undefined || value === "" ? "N/A" : value;

  return (
    <Box
      sx={{
        py: 1.15,
        borderBottom: `1px solid ${BRAND.border}`,
        "&:last-child": { borderBottom: "none", pb: 0 },
      }}
    >
      <ProfileFieldLabel>{label}</ProfileFieldLabel>
      <Typography
        sx={{
          color: display === "N/A" ? BRAND.muted : BRAND.navy,
          fontWeight: display === "N/A" ? 400 : 500,
          fontSize: "0.9375rem",
          lineHeight: 1.5,
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {display}
      </Typography>
    </Box>
  );
};

export const ProfileSectionCard = ({ title, action, children }) => (
  <Box
    sx={{
      bgcolor: "#fff",
      borderRadius: "12px",
      border: `1px solid ${BRAND.border}`,
      overflow: "hidden",
      mb: 1.5,
    }}
  >
    {title && (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          py: 1.25,
          borderBottom: `1px solid ${BRAND.border}`,
        }}
      >
        <Typography sx={{ fontWeight: 700, color: BRAND.navy, fontSize: "0.9375rem" }}>
          {title}
        </Typography>
        {action}
      </Box>
    )}
    <Box sx={{ px: 1.5, py: 0.5 }}>{children}</Box>
  </Box>
);

export const ProfileFieldList = ({ fields }) => (
  <Stack spacing={0}>
    {fields.map(({ label, value }) => (
      <ProfileField key={label} label={label} value={value} />
    ))}
  </Stack>
);

export const DesktopDetailGrid = ({ fields }) => (
  <>
    {fields.map(({ label, value }) => (
      <Typography key={label}>
        <strong>{label}:</strong> {value ?? "N/A"}
      </Typography>
    ))}
  </>
);
